import React from 'react';
import {EventPublic} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';

export default React.createContext<EventPublic[] | null>(null);
